<div class="main-container">
  <div class="rr-container-white pb-3">
    <div class="">
      <h3 class="mb-0"><span class="px-2"><i class="fas fa-file-alt"></i></span> Well Files</h3>
      <p>View, upload, and manage files for each of your wells. Organize documents and pictures by well to share with your team.</p>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <div *ngIf="selectedWell && hasWellFilesAccess">
        <div *ngIf="isLoadingWellList" style="position: relative; bottom: -30px; left: 60px; z-index: 10;">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
          </div>
        </div>
        <p-dropdown
                    [options]="wellOptions"
                    [(ngModel)]="selectedWellID"
                    [filter]="true"
                    [disabled]="isLoadingWellList"
                    [virtualScroll]="true"
                    itemSize="30"
                    styleClass="wells-dropdown"
                    scrollHeight="250px"
                    [resetFilterOnHide]="true"
                    placeholder="Select a well"
                    (onChange)="onWellSelect($event.value)">
          <ng-template pTemplate="selectedItem">
            <div *ngIf="selectedWell">
              <div><strong>{{selectedWell.wellName}}</strong><span class="text-muted" style="font-size: smaller" *ngIf="selectedWell.apiNumber != ''"> - API#{{selectedWell.apiNumber}}</span></div>
            </div>
          </ng-template>
          <ng-template let-well pTemplate="item">
            <div>
              <div>{{well.wellName}}<span class="text-muted" *ngIf="well.apiNumber != ''"> - API#{{well.apiNumber}}</span></div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div>
    </div>
  </div>

  <div class="rr-container-color" style="min-height: 95vh;">
    <div style="text-align: center; padding: 4em 1em" *ngIf="!hasWellFilesAccess">
      <div class="py-4">
        <img src="/assets/no-dashboard-img.svg" alt="No dashboards image" style="height: 125px;" />
      </div>
      <h5 class="pb-2"><strong>You do not currently have the necessary permissions to access the Well Files module.</strong></h5>
      <p>To request access to Well Files please contact the <a href="mailto:support@mi4.com">Mi4 Support Team</a> or your administrator.</p>
      <p class="text-muted"><em>If you were recently granted access and are still seeing this page, please log out and log back in again to refresh your permissions.</em></p>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="hasWellFilesAccess">
      <div class="py-4">
        <img src="/assets/no-data-img.svg" alt="No data image" style="height: 125px;" />
      </div>
      <div class="text-danger fw-700">
        <strong>{{errorSelectedWell}}</strong>
      </div>
      <label *ngIf="selectedWellID == null">Choose a well from the following list</label>
      <div class="text-danger fw-700">
        <strong>{{errorWellList}}</strong>
      </div>
      <div *ngIf="isLoadingWellList && (selectedWellID == null)" style="position: relative; bottom: -30px; z-index: 10;">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
        </div>
      </div>
      <div *ngIf="selectedWellID == null">
        <p-dropdown [options]="wellOptions"
                    [(ngModel)]="selectedWellID"
                    [disabled]="isLoadingWellList"
                    [filter]="true"
                    [resetFilterOnHide]="true"
                    [virtualScroll]="true"
                    itemSize="30"
                    scrollHeight="250px"
                    styleClass="wells-dropdown"
                    placeholder="Select a well"
                    (onChange)="onWellSelect($event.value)">
          <ng-template let-well pTemplate="item">
            <div>
              <div>{{well.wellName}}<span class="text-muted" *ngIf="well.apiNumber != ''"> - API#{{well.apiNumber}}</span></div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div *ngIf="isLoadingWellList && (selectedWellID != null)">
        <app-loading-indicator [large]="true" [message]="'Loading data for the selected well'"></app-loading-indicator>
      </div>
    </div>
  </div>
</div>
